// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__9PK9J","footer":"ChangeClinic_footer__2_8h_"};